import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getTeamUrl, priceGroupIdUrl } from "src/react-query/endPoints";
import { useCallback, useMemo } from "react";
import { FEATURE } from "src/util/enums";
export const PriceGroupActionMenu = ({ id, row }) => {
  const isReadOnly = useAccess(FEATURE.PRICEGROUP, "R");
  const hasEditAccess = useAccess(FEATURE.PRICEGROUP, "U");
  const hasDeleteAccess = useAccess(FEATURE.PRICEGROUP, "D");
  const { mutate } = useMutate("priceGroups");
  
  // Use the price group's own companyId instead of the currently selected team
  const priceGroupCompanyId = row?.companyId;
  
  const onDelete = useCallback(() => {
    mutate({ url: getTeamUrl(priceGroupCompanyId, priceGroupIdUrl(id)), method: "DELETE" });
  }, [priceGroupCompanyId, id, mutate]);
  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `${id}`,
        hidden: !hasEditAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
        hidden: !hasDeleteAccess,
      },
    ],
    [id, isReadOnly, hasEditAccess, hasDeleteAccess, onDelete]
  );

  return <ActionsMenu menuList={actionList} />;
};
